export { default as ReceivingListTemplate } from './ReceivingListTemplate';
export { default as ReceivingEditTemplate } from './ReceivingEditTemplate';
export { default as ReceivingDetailTemplate } from './ReceivingDetailTemplate';
export { default as ReceivingHistoryLogList } from './ReceivingHistoryLogList';
export { default as ReceivingHistoryLogListTemplate } from './ReceivingHistoryLogListTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/index.js